import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ButtonDirective } from "primeng/button";

import { VersionCheckService } from "../../shared/version/version-check.service";

@Component({
  selector: "app-version-alert",
  templateUrl: "./version-alert.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./version-alert.component.scss"],
  imports: [ButtonDirective],
})
export class VersionAlertComponent {
  public versionCheck = inject(VersionCheckService);
}
